export default __webpack_public_path__ + "static/media/Headshot-0.cf504e4e.png";